import { MetricLabelsConfiguration } from "../../Molecules/Configurations/AdvancedMetrics/MetricsLabelsConfiguration";
import { SystemLabelConfiguration } from "../../Molecules/Configurations/AdvancedMetrics/SystemLabelsConfiguration";
import { ItemsConfigurations } from "../../Molecules/Configurations/ItemsConfigurations/ItemsConfigurations";
import { MetricsConfigurations } from "../../Molecules/Configurations/Metrics/MetricsConfigurations";
import { SelectMetricLabelsConfiguration } from "../../Molecules/Configurations/Metrics/SelectMetricsConfigurations";
import { ThresholdsConfigurations } from "../../Molecules/Configurations/ThresholdsConfigurations/ThresholdsConfigurations";
import { UsersConfigurations } from "../../Molecules/Configurations/UsersConfigurations";
import { WidgetConfigurations } from "../../Molecules/Configurations/WidgetConfigurations";

export const ConfigurationsSubTabs = [
  {
    name: "Users",
    label: "users",
    submenus: null,
    component: [UsersConfigurations],
    buttons: ['Users Configurations'],
    subTabsPath: ['users-configurations'],
    path: 'users'
  },
  {
    name: "Items",
    label: "items",
    submenus: null,
    component: [ItemsConfigurations],
    buttons: ['Items Configurations'],
    subTabsPath: ['items-configurations'],
    path: 'items'
  },
  {
    name: "Widgets",
    label: "widgets",
    buttons: ['Widget Configurations'],
    component: [WidgetConfigurations],
    submenus: null,
    subTabsPath: ['widget-configurations'],
    path: 'widget'
  },
  {
    name: "Metrics",
    label: "metrics",
    buttons: ['Select Metric Labels', 'Metrics Configurations'],
    component: [SelectMetricLabelsConfiguration, MetricsConfigurations],
    submenus: null,
    subTabsPath: ['select-metric-labels', 'metrics-configurations'],
    path: 'metrics'
  },
  {
    name: "Advanced Metrics",
    label: "advancedMetrics",
    submenus: null,
    buttons: ['Metric Labels Configuration', 'System Label Mapping Configuration'],
    component: [MetricLabelsConfiguration, SystemLabelConfiguration],
    subTabsPath: ['metric-labels', 'system-labels'],
    path: 'advanced-metrics'
  },
  {
    name: "Thresholds",
    label: "configurations_thresholds",
    submenus: null,
    buttons: ['Thresholds'],
    component: [ThresholdsConfigurations],
    subTabsPath: ['thresholds-configurations'],
    path: 'thresholds'
  },
]
